export default __webpack_public_path__ + "static/media/react.eda23d58.png";